import PagingButtons from "./PagingButtons";

export default PagingButtons;
